import { render, staticRenderFns } from "./SlideoutMenu.vue?vue&type=template&id=5520be0d&scoped=true&"
import script from "./SlideoutMenu.vue?vue&type=script&lang=js&"
export * from "./SlideoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./SlideoutMenu.vue?vue&type=style&index=0&id=5520be0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520be0d",
  null
  
)

export default component.exports